import { render } from "./ImpresionesList.vue?vue&type=template&id=05f01448&scoped=true"
import script from "./ImpresionesList.vue?vue&type=script&lang=js"
export * from "./ImpresionesList.vue?vue&type=script&lang=js"

import "./ImpresionesList.vue?vue&type=style&index=0&id=05f01448&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f01448"]])

export default __exports__